export default "__VITE_ASSET__8a872d86__"